module.exports = __webpack_public_path__ + "static/carpenter-working-24190d3cf8e44ac7c117d1f6486b5970.png";